<template>
  <div class="o-page__content u-pt-small">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12 col-xl-12">
          <h1 class="u-h3">Logs</h1>
          <div class="custom_toolbar">
            <input
              type="text"
              placeholder="Search npp..."
              class="c-input"
              v-model="params.q"
              v-on:keyup="search"
            />
          </div>
        </div>
      </div>
      <div class="row u-mt-medium">
        <!-- filter date range -->
        <div class="col-12 u-mb-small">
          Filter last login
          <el-date-picker
            v-model="valueFilterDataRange"
            type="daterange"
            range-separator="To"
            start-placeholder="Start date"
            end-placeholder="End date"
            @change="filterDate"
          >
          </el-date-picker>
          <el-button class="u-ml-small" type="primary" @click="resetFilterDateRange"
            >Reset Filter</el-button
          >
        </div>
        <div class="col-12">
          <vue-good-table
            v-loading="loading"
            mode="remote"
            :columns="columns"
            :rows="rows"
            :totalRows="totalRecords"
            @on-page-change="onPageChange"
            @on-per-page-change="onPageChange"
            :select-options="{
              enabled: true,
              selectOnCheckboxOnly: true,
              disableSelectInfo: true,
            }"
            :pagination-options="{
              enabled: true,
              mode: 'pages',
            }"
          >
            <template slot="table-row" slot-scope="props">
              <span v-if="props.column.field == 'entity'">
                {{ props.row.entity.toUpperCase() }}
              </span>
              <span v-else-if="props.column.field == 'is_succeed'">
                <el-tag type="success" v-if="props.row.is_succeed" size="mini"
                  >Success</el-tag
                >
                <el-tag type="danger" v-if="!props.row.is_succeed" size="mini"
                  >Failed</el-tag
                >
              </span>
              <span v-else-if="props.column.field == 'ip_address'">
                <p v-if="props.row.ip_address == '34.101.136.163'">
                  BNI Learning Service
                </p>
                <p v-else-if="props.row.ip_address == '34.101.199.1'">
                  e-Branch Sharing Session
                </p>
                <p v-else>{{ props.row.ip_address }}</p>
              </span>
              <span v-else>
                {{ props.formattedRow[props.column.field] }}
              </span>
            </template>
          </vue-good-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import "vue-good-table/dist/vue-good-table.css";
import { VueGoodTable } from "vue-good-table";
import api from "@/api/logs";
import moment from "moment";

export default {
  components: {
    "vue-good-table": VueGoodTable,
  },
  data() {
    return {
      valueFilterDataRange: "",
      start_date: "",
      end_date: "",
      columns: [
        {
          label: "NPP",
          field: "npp",
        },
        {
          label: "Action",
          field: "entity",
        },
        {
          label: "Status",
          field: "is_succeed",
        },
        {
          label: "Message",
          field: "message",
        },
        // {
        //     label: 'Description',
        //     field: 'description'
        // },
        // {
        //   label: "IP Address",
        //   field: "ip_address",
        // },
        {
          label: "Application",
          field: "ip_address",
        },
        {
          label: "Date",
          field: this.dateField,
        },
      ],
      rows: [],
      totalRecords: 0,
      page: 1,
      perPage: 10,
      params: {
        q: "",
      },
      loading: false,
    };
  },
  created() {
    this.fetch();
  },
  methods: {
    ...mapActions(["logout"]),
    dateField(rowObj) {
      return moment(rowObj.created_at).format("dddd, DD MMMM YYYY / H:mm:ss");
    },
    fetch() {
      this.loading = true;
      var self = this;
      api
        .get(this.page, this.params.q, this.perPage, this.start_date, this.end_date)
        .then(function (response) {
          self.rows = response.data.data;
          self.totalRecords = response.data.meta.totalRecords;
          self.loading = false;
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.status == 403) {
            self.logout();
          }
        });
    },
    onPageChange(params) {
      console.log(params);
      this.page = params.currentPage;
      this.perPage = params.currentPerPage;
      this.fetch();
    },
    search() {
      this.fetch();
    },
    filterDate() {
      // yyyy-mm-dd hh:mm:ss
      this.start_date = moment(this.valueFilterDataRange[0]).format(
        "YYYY-MM-DD HH:mm:ss"
      );
      this.end_date = moment(this.valueFilterDataRange[1]).format("YYYY-MM-DD HH:mm:ss");
      // console.log("start_date", start_date);
      // console.log("end_date", end_date);
      this.fetch();
    },
    resetFilterDateRange() {
      this.valueFilterDataRange = ""
      this.start_date = ""
      this.end_date = ""
      this.fetch();
    }
  },
};
</script>

<style lang="scss" scoped>
.custom_toolbar {
  display: flex;
  div {
    margin-right: 10px;
  }
}
</style>
